import React, { useEffect, useState } from 'react';
import { Card, Row, Col, Container } from 'reactstrap';
import whatnewConfig from './whatnewConfig';
import "../../css/whatnew.css";
import config from '../../config/config';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { actFecthYearEndWrap } from '../../actions';

const WhatNew = () => {
    const dispatch = useDispatch();
    const { hasYearEnd } = useSelector(state => state.commonSetting);
    const [show, setShow] = useState('All');
    const [dataConfig, setDataConfig] = useState(whatnewConfig);
    const history = useHistory();

    const filter = [
        {
            filter: "All",
            color: "#005CB1",
            text: "#fff",
        },
        {
            filter: "New feature",
            color: "#007F5F",
            text: "#fff",
            gradient: ["#0055A5", "#bcd0e6"]
        },
        {
            filter: "Improvement",
            color: "#FFD233",
            text: "#000",
            gradient: ["#EFDA90", "#007F5F"]
        },
        {
            filter: "Announcement",
            color: "#863BE8",
            text: "#fff",
            gradient: ["#5EFCE8", "#736EFE"]
        },

    ];

    const getItem = (item, index) => {
        if (show == "All") {
            return (
              <div key={index}>
                {item?.modal == "yearend"
                  ? hasYearEnd && cardMarkup(item)
                  : cardMarkup(item)}
              </div>
            );
        } else {
            if (item.filter == show) {
                return (
                    <div key={index}>
                        {item?.modal == "yearend" ? hasYearEnd && cardMarkup(item) : cardMarkup(item)}
                    </div>
                )
            }
        }
    }

    const getStyle = (value) => {
        let obj = filter.find(obj => obj.filter === value);
        if (obj) {
            let style = {
                backgroundColor: obj.color,
                color: obj.text
            }
            return style;
        } else {
            let style2 = {
                backgroundColor: filter[0].color,
                color: filter[0].text
            }
            return style2;
        }
    }

    const getRandom = (list) => {
        return list[Math.floor((Math.random() * list.length))];
    }

    const getGradient = (value) => {
        let obj = filter.find(obj => obj.filter === value);
        let position = getRandom(['left', 'top', 'right', 'bottom', "right", "left", "bottom", "top"]);
        if (obj) {
            let style = {
                backgroundImage: `linear-gradient(to ${position}, ${obj.gradient[0]}, ${obj.gradient[1]})`,
                borderRadius: "10px",
            }
            return style;
        } else {
            let style = {
                backgroundColor: `linear-gradient(to ${position}, #0055A5, #FFFFFF)`
            }
            return style;
        }
    }

    const cardMarkup = (item) => (
      <Card className="mt-5">
        <div className="what-new-card-top">
          <span
            className="what-new-badge"
            style={getStyle(item.filter)}
          >
            {item.filter}
          </span>
          <span>{item.date}</span>
        </div>
        <p dangerouslySetInnerHTML={{ __html: item.title }}></p>
        <div
          className="what-new-background"
          style={getGradient(item.filter)}
        >
          <img
            src={item.img}
            alt={item.title}
          />
        </div>
        <div className="text-center what-new-button">
          {item.tab && (
            <span className="">
              <span
                onClick={() => {
                  history.push(
                    config.pathName + item.tab + config.urlParamsValue,
                  );
                }}
              >
                {item.button}
              </span>
            </span>
          )}
          {item.href && (
            <span className="what-new-button">
              <a
                href={item.href}
                target="_blank"
              >
                {item.button}
              </a>
            </span>
          )}
          {item.file && (
            <span className="what-new-button">
              <a
                href={item.file}
                download="BLACK_FRIDAY_CAMPAIGN_GUIDE.pdf"
                target="_blank"
              >
                {item.button}
              </a>
            </span>
          )}
          {item.modal == "yearend" && (
            <span className="">
              <span
                onClick={() => {
                    dispatch(actFecthYearEndWrap(true));
                }}
              >
                {item.button}
              </span>
            </span>
          )}
        </div>
      </Card>
    );

    useEffect(() => {
        window.scrollTo(0, 0);
    }, [show]);


    return (
        <div className="what-new-wrapper">
            <Container>
                <Row>
                    <Col md={11} className="">
                        {dataConfig.map((item, index) => getItem(item, index) )}
                    </Col>
                    <Col md={1} className="what-new-filter-wrap">
                        <div className="what-new-filter">
                            {filter.map((item, index) => (
                                <div
                                    key={index}
                                    className={show === item.filter ? `what-new-filter-inner active-badge` : 'what-new-filter-inner'}
                                    onClick={() => {
                                        setShow(item.filter);
                                        // getDataConfig(item.filter)
                                    }}
                                >
                                    <div className="circle-point" style={{backgroundColor: filter[index].color}}></div>
                                    <span>{ item.filter }</span>
                                </div>
                            ))}
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default WhatNew;